module.exports = __webpack_public_path__ + "assets/img/140.9a62af16.png";